import { Box, Text } from '@wix/design-system';
import * as React from 'react';
export const InfoLine = ({ children, ...props }) => (React.createElement(Box, { paddingTop: "4px" },
    React.createElement(Text, { size: 'tiny', secondary: true, ...props }, children)));
//# sourceMappingURL=InfoLine.js.map